<template>
  <!-- deviceTypes 设备类型-->
  <div class="mapping">
    <div class="content">
      <div class="newtable-title">
        <div class="left-t">
        </div>
        <div class="btns">
          <el-button type="primary" @click="add_ed">新增</el-button>
        </div>

      </div>
      <div class="mapping-table">
        <el-table :data="tableData" stripe style="width: 100%" border :max-height="heights">
          <el-table-column label="序号" width="50" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceTypeName" label="设备类型名称" min-width="305"> </el-table-column>
          <el-table-column prop="picture" label="设备图片" min-width="104">
            <template #default="{row}">
              <el-image style="width: 50px; height: 50px" :src="row.picture" :preview-src-list="[row.picture]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="144">
            <template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="284">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button type="text" @click="edit_ed(row)" style="color:#409eff;font-weight: bold">修改</el-button>
                <el-button type="text" @click="delete_fn(row)" style="color:red;font-weight: bold">删除</el-button>
                <el-button type="text" @click="moded(row)" style="color:green;font-weight: bold">设备模板编辑</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->
    <el-dialog width="600px" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div>
        <el-form :model="temp" ref="temp" :rules="rules" label-width="60px">
          <el-form-item label="设备类型名称:" prop="deviceTypeName">
            <el-input v-model="temp.deviceTypeName"></el-input>
          </el-form-item>
          <el-form-item label="设备图片:" prop="picture">
            <el-upload action="" :show-file-list="false" :auto-upload="false" accept="image/*" list-type="picture-card"
              :on-change="icon_fn">
              <el-image v-if="temp.picture" :src="temp.picture" class="avatar"></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 设备类型模板 -->
    <el-dialog width="900px" v-dialogDrag title="设备类型模板" :close-on-click-modal='false' :visible.sync="dialogAddress">
      <div class="address" style="
      margin-right: 20px; 
      padding-bottom: 20px;
  ">
        <el-button type="primary" @click="add_ed2">新增</el-button>
        <el-table :data="tableData2" stripe style="width: 100%" border>
          <el-table-column label="序号" width="50" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceTypeTemplateName" label="设备类型模板" />
          <el-table-column prop="appTypeName" label="应用类型名称" />
          <el-table-column prop="appTypeNo" label="应用类型编号" />
          <el-table-column label="操作" align="center" width="104">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button type="text" @click="delete_fn2(row)" style="color:red;font-weight: bold">删除</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 新增修改 -->
    <el-dialog width="600px" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible2">
      <el-form :model="temp" ref="temp" :rules="rules" label-width="60px">
        <el-form-item label="设备类型模板名称:" prop="deviceTypeTemplateName">
          <el-input v-model="temp.deviceTypeTemplateName"></el-input>
        </el-form-item>
        <el-form-item label="应用类型组:" prop="appTypeGroupId">
          <el-select v-model="temp.appTypeGroupId" filterable placeholder="请选择应用类型组" clearable>
            <el-option v-for="(item,i) in options" :key="i" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用类型:">
          <el-select v-model="temp.deviceTypeld" filterable placeholder="请选择应用类型" clearable @change="optionsFn">
            <el-option v-for="(item,i) in typeOptions" :key="i" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn2('temp')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getMappingList,setMappingSave,mappingUpdate,mappingStatus,capacityFindById,capacitySaveRemote,capacityStatusRemote} from "../../api/capacity";
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import {getAllTypeByGroup} from "../../api/energySubType";
  import {getAppTypeByGroupId} from "../../api/energySubType";
  import request from "@/api/http.js";
  export default {
    components: {
      elRadioTree,
      elCheckBoxTree,
      downloadTable
    },
    data () {
      return {
        typeOptions: [],
        tableData2: [],//设备类型模板数据
        moded_id: '',
        options: [],//应用类型组数据
        heights: document.getElementById('app').clientHeight-220,//屏幕高度 - 导航栏高度
        loading: true,
        dialogVisible: false,
        dialogVisible2: false,
        dialogAddress: false,
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        temp: {
          'deviceTypeName': "",
          'localDevices': "",
          'localDeviceNos': ""
        },
        remote: {
          remoteUrl: ""
        },
        rules: {
          deviceTypeName: [
            {required: true,message: '请输入设备类型名称',trigger: 'blur'}
          ],
          localDevices: [
            {required: true,message: '请选择能耗设备',trigger: 'blur'}
          ],
          remotDevice: [
            {required: true,message: '请选择EMS设备',trigger: 'blur'}
          ],
          picture: [
            {required: true,message: '请上传图片',trigger: 'change'}
          ],
        },
        remRules: {
          remoteUrl: [
            {required: true,message: '请输入远程地址',trigger: 'blur'}
          ],
        },
        tableData: [],
        remoteFlag: false
      };
    },
    mounted () {
      getAllTypeByGroup().then(res => {
        this.options=res.data;
      })
      this.getList()
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
      nowVirtualDevice () {
        return this.$store.deviceStore.state.nowVirtualDevice
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
    },
    watch: {
      'temp.appTypeGroupId': function(val) {
        if(val==''||!val) {
          this.typeOptions=[]
          this.$set(this.temp,'deviceTypeld','')
          return
        }
        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data;
            this.$set(this.temp,'deviceTypeld','')
          }
        })
      },
      unitId () {
        this.getList() // 获取列表数据 
      },
      nowVirtualDevice (nv) {
        this.temp.localDevices=nv.name
        this.temp.localDeviceNos=nv.no
      }
    },

    methods: {
      optionsFn (v) {
        this.typeOptions.map(a => {
          if(a.id==v) {
            this.temp.appTypeName=a.name;
            this.temp.appTypeNo=a.no;
          }
        })
      },
      // 设备类型->根据设备类型Id获取设备类型模板
      moded (row) {
        this.tableData2=[];
        this.moded_id=row.id;
        var params={id: row.id}
        request({url: "/deviceClassification/getDeviceTypeTemplateById",method: "get",params}).then(res => {
          console.log(res,11);
          if(res.code==200) {
            this.tableData2=res.data;
            this.dialogAddress=true;
          }
        })
      },
      //上传自定义图标
      icon_fn (file) {
        this.getBase64(file.raw).then(res => {
          this.$set(this.temp,'picture',res)
        })
      },
      getBase64 (file) {
        return new Promise(function(resolve,reject) {
          const reader=new FileReader()
          let imgResult=''
          reader.readAsDataURL(file)
          reader.onload=function() {
            imgResult=reader.result
          }
          reader.onerror=function(error) {
            reject(error)
          }
          reader.onloadend=function() {
            resolve(imgResult)
          }
        })
      },
      //获取数据
      getList () {
        var id=this.unitId.id
        this.loading=true
        request({url: "/deviceClassification/getDeviceTypeAll",method: "get"}).then(res => {
          this.loading=false;
          console.log(res,111);
          if(res.code==200) {
            this.tableData=res.data;
          }
        })
      },
      //获取远程接口
      remote_fn () {
        this.remote={}
        capacityFindById({'unitId': this.unitId.id}).then(res => {
          if(res.data) {
            this.remote=res.data
            this.remoteFlag=true
          } else {
            this.remote={}
            this.remoteFlag=false
          }
        })
      },
      //保存远程接口
      saveRemote () {
        this.$refs['remote'].validate(valid => {
          if(valid) {
            var d={
              remoteUrl: this.remote.remoteUrl,
              unitId: this.unitId.id
            }
            if(this.remoteFlag) {
              d.id=this.remote.id
            }
            capacitySaveRemote(d).then(res => {
              if(res.code==200) {
                this.dialogAddress=false
                this.remote_fn()
                this.$message({showClose: true,message: '设置远程地址成功',type: 'success'});
              } else {
                res.message? this.$message.error(res.message):this.$message.error('设置远程地址失败')
              }
            })


          } else {
            return false;
          }
        });
      },

      // 删除 模板
      delete_fn2 (v) {
        console.log(v);
        this.$confirm(`是否删除 ${v.deviceTypeTemplateName} 模板`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={id: v.id}
          request({url: "/deviceClassification/deleteDeviceTypeTemplate",method: "delete",params}).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.moded({id: this.moded_id})
            } else {
              this.$message.error(`删除失败，${res.message}`);
            }
          })
          // apptypeDeleteById({'no': v.no}).then(res => {

          // })
        })

      },

      // 删除
      delete_fn (v) {
        this.$confirm(`是否删除 ${v.deviceTypeName}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={id: v.id}
          request({url: "/deviceClassification/deleteDeviceType",method: "delete",params}).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.getList();
            } else {
              this.$message.error(`删除失败，${res.message}`);
            }
          })
          // apptypeDeleteById({'no': v.no}).then(res => {

          // })
        })

      },
      // 添加弹窗
      add_ed () {
        this.temp={
          deviceTypeName: '',
          picture: '',
        }
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 添加 设备类型模板弹窗
      add_ed2 () {
        this.temp={
          deviceTypeTemplateName: '',
          appTypeGroupId: '',
          deviceTypeld: ''
        }
        this.dialogStatus='add';
        this.dialogVisible2=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认添加 设备类型模板
      add_fn2 (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var data=this.temp
            data.deviceTypeId=this.moded_id;
            request({url: "/deviceClassification/saveDeviceTypeTemplate",method: "post",data}).then(res => {
              if(res.code==200) {
                this.moded({id: this.moded_id})
                this.dialogVisible2=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },

      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var data=this.temp
            request({url: "/deviceClassification/saveDeviceType",method: "post",data}).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.uid=data.id;
            request({url: "/deviceClassification/saveDeviceType",method: "post",data}).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('修改失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },

      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .mapping {
    width: 100%;
    // height: calc(100% - 125px) !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 12px 20px;
      box-sizing: border-box;

      .mapping-table {
        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    .newtable-title {


      display: flex;
      // align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;

      span {
        color: #67A3ED;
        font-size: 16px;
      }

      .el-icon-close {
        font-size: 22px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #f5f5f5;

      button {
        padding: 8px 17px;
      }
    }

    /deep/.el_Tree_Body {
      height: 99.5%;
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    .address {
      /deep/.el-form-item__content {
        width: 100%;
        display: flex;
        align-items: center;
      }

      button {
        height: 34px;
      }
    }

    .device-tree {
      height: 100%;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    /deep/.el-input__inner {
      height: 34px;
      line-height: 34px;
    }
  }
</style>